import { Injectable } from '@angular/core';
import { UIRouter } from '@uirouter/angular';
import { BsModalService } from 'ngx-bootstrap/modal';

export class StateTransitionOptions {
    reload: boolean;
}

@Injectable({ providedIn: 'root' })
export class UpgradeNavigationServiceHandler {
    constructor(private readonly _uiRouter: UIRouter,
                private readonly _bsModalService: BsModalService) {
    }

    transitionTo(newState: string, params: any, options?: StateTransitionOptions): void {
        if (options) {
            this._uiRouter.stateService.transitionTo(newState, params, options);
        } else {
            this._uiRouter.stateService.transitionTo(newState, params);
        }
    }

    go(stateName: string, params: any, closeModal?: boolean): void {
        if (closeModal){
            this._bsModalService.hide();
        }
        this._uiRouter.stateService.go(stateName, params);
    }

    goWithReload(stateName: string, params: any): void {
        this._uiRouter.stateService.go(stateName, params, { reload: true });
    }

    getCurrentState(): any {
        return this._uiRouter.globals.current;
    }

    getQuerystringParam(parameterName: string): string {
        return this._uiRouter.globals.params[parameterName];
    }

    goToAnnualDetailsAssessment(companyID: number, siteID: number, parcelID: number, annualYearID: number, assessmentID: number): void {
        this._bsModalService.hide();

        this._uiRouter.stateService.go('parcel', {
            annualAssessmentID: assessmentID,
            siteId: siteID,
            companyId: companyID,
            annualYearID: annualYearID,
            parcelId: parcelID
        });
    }

    goToAnnualDetailsAppeal(companyID: number, siteID: number, parcelID: number, annualYearID: number, assessmentID: number, appealID: number): void {
        this._bsModalService.hide();

        this._uiRouter.stateService.go('parcel', {
            annualAssessmentID: assessmentID,
            siteId: siteID,
            companyId: companyID,
            annualYearID: annualYearID,
            parcelId: parcelID,
            appealID: appealID
        });
    }

    goToAnnualDetailsTax(companyID: number, siteID: number, parcelID: number, annualYearID: number, billClusterID: number): void {
        this._bsModalService.hide();

        this._uiRouter.stateService.go('parcel', {
            billClusterID: billClusterID,
            siteId: siteID,
            companyId: companyID,
            annualYearID: annualYearID,
            parcelId: parcelID
        });
    }

    goToAnnualDetailsRefund(companyID: number, siteID: number, parcelID: number, annualYearID: number, refundID: number): void {
        this._bsModalService.hide();

        this._uiRouter.stateService.go('parcel', {
            refundID: refundID,
            siteId: siteID,
            companyId: companyID,
            annualYearID: annualYearID,
            parcelId: parcelID
        });
    }

    goToAnnualDetailsFiling(companyID: number, siteID: number, parcelID: number, annualYearID: number, filingId: number): void {
        this._bsModalService.hide();

        this._uiRouter.stateService.go('parcel', {
            filingId: filingId,
            siteId: siteID,
            companyId: companyID,
            annualYearID: annualYearID,
            parcelId: parcelID
        });
    }

    goToFilingBatch(filingBatchId: number): void {
        this._bsModalService.hide();

        this._uiRouter.stateService.go('returnFilingBatchPage', {
            filingBatchId: filingBatchId
        });
    }

    getHrefFromState(stateName: string, options: any): string {
        return this._uiRouter.stateService.href(stateName, options, {absolute: true});
    }
}
